import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import './input.css';

class DateInput extends Component {
    state = {
        focused: false
    };

    handleChange = (e) => {
        this.props.onChange && this.props.onChange(e);
    }
    setFocused = (e) => {
        this.setState({ focused: true });
    }
    setBlure = (e) => {
        this.setState({ focused: false });
    }
    render() {
        let { error, selected, name, placeholderText } = this.props;
        error = error === undefined ? '' : error;

        return (
            <div className="MuiFormControl-root MuiTextField-root" style={{marginTop: '15px'}}>
                {placeholderText !== null && <label className={`MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated Mui-focused MuiInputLabel-shrink ${error !== '' && this.state.focused ? 'Mui-error' : ''}`} htmlFor={name}>{placeholderText}</label>}
                <div className={`MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl ${this.state.focused ? "Mui-focused" : ""} ${error !== '' ? 'Mui-error' : ''}`}>
					<DatePicker name={name} selected={selected} onChange={this.handleChange} placeholderText="mm/dd/yyyy" className="form-control pl-0 pr-0" />
                </div>
                {error !== '' && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-filled">{error}</p>}
            </div>
        );
    }
}

export default DateInput;